// extracted by mini-css-extract-plugin
export var subtitle = "_de-2";
export var title = "_de-0";
export var titleNoWrap = "_de-1";